import salesItemsApi from '../../repos/sales-items'
import timeHasPassed from '../../timeHasPassed'

const state = {
    lastFetchTime: null,
    byStoreId: null,
    items: []
};

const getters = {
    getById: state => (id) => {
        return state.items.find(item => item.id === id);
    },
    hasFetchedForId: state => (id) => {
        return (state.byStoreId === id && state.lastFetchTime !== null);
    }
};

const actions = {
    getAll({ state, commit }, storeId) {
        if (
            state.byStoreId === storeId
            && state.lastFetchTime !== null
            && !timeHasPassed(state.lastFetchTime, 600)
        ) {
            return Promise.resolve();
        }

        return salesItemsApi.getAll(storeId)
            .then(response => {
                commit('itemsFetchSuccess', {
                    storeId,
                    items: response.data
                });
            })
        ;
    },
    create({ state, commit }, item) {
        return salesItemsApi.post(state.byStoreId, item)
            .then(response => {
                commit('itemCreateSuccess', response.data);
                return response;
            })
        ;
    },
    update({ state, commit }, item) {
        return salesItemsApi.put(state.byStoreId, item)
            .then(response => {
                commit('itemUpdateSuccess', response.data);
                return response;
            })
        ;
    },
    delete({ state, commit }, itemId) {
        return salesItemsApi.delete(state.byStoreId, itemId)
            .then(() => {
                commit('itemDeleteSuccess', itemId);
            })
        ;
    }
};

const mutations = {
    itemsFetchSuccess(state, { storeId, items }) {
        state.lastFetchTime = Date.now();
        state.byStoreId = storeId;
        state.items = items;
    },
    itemCreateSuccess(state, item) {
        state.items.push(item);
    },
    itemUpdateSuccess(state, item) {
        state.items = [
            ...state.items.filter(filterItem => filterItem.id !== item.id),
            item
        ];
    },
    itemDeleteSuccess(state, itemId) {
        state.items = [
            ...state.items.filter(filterItem => filterItem.id !== itemId)
        ];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
